module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.showSettingDialog),
      callback: function($$v) {
        _vm.showSettingDialog = $$v
      },
      expression: "showSettingDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', [(_vm.selectEditServiceId == 1) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.flow-and-time')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.ro-membrane')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.temperature')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.pressure')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSettingDialog(false)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('h4', {
    staticClass: "setting-dialog-threshold-h"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.threshold')))]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.openHelpDialog()
      }
    }
  }, [_c('v-icon', {
    staticClass: "body-1",
    attrs: {
      "large": ""
    }
  }, [_vm._v("info")]), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-flow-and-time')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-ro-membrane')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-temperature')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-pressure')))]) : _vm._e()], 1), _vm._v(" "), _c('help-dialog', {
    ref: "childHelpDialog"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.presetRadio),
      callback: function($$v) {
        _vm.presetRadio = $$v
      },
      expression: "presetRadio"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('watersystem.custom'),
      "value": "0"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('watersystem.use-preset'),
      "value": "1",
      "disabled": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "settingForm",
    model: {
      value: (_vm.settingDialogValid),
      callback: function($$v) {
        _vm.settingDialogValid = $$v
      },
      expression: "settingDialogValid"
    }
  }, [(_vm.selectEditServiceId == 1) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t("watersystem.flow-life")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.alert")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.unit,
      "rules": _vm.lifespanFrowRateAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.maxFlowLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "maxFlowLifeSpan", $$v)
      },
      expression: "flowEditData.maxFlowLifeSpan"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.warning")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.unit,
      "rules": _vm.lifespanFrowRateWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.warningFlowLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "warningFlowLifeSpan", $$v)
      },
      expression: "flowEditData.warningFlowLifeSpan"
    }
  })], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("watersystem.time-life")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.alert")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.$t("watersystem.period-month"),
      "rules": _vm.lifespanMonthAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.maxUptimeLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "maxUptimeLifeSpan", $$v)
      },
      expression: "flowEditData.maxUptimeLifeSpan"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.warning")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.$t("watersystem.period-month"),
      "rules": _vm.lifespanMonthWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.warningUptimeLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "warningUptimeLifeSpan", $$v)
      },
      expression: "flowEditData.warningUptimeLifeSpan"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": "%",
      "rules": _vm.roRateAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.roEditData.alertRate),
      callback: function($$v) {
        _vm.$set(_vm.roEditData, "alertRate", $$v)
      },
      expression: "roEditData.alertRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": "%",
      "rules": _vm.roRateWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.roEditData.warningRate),
      callback: function($$v) {
        _vm.$set(_vm.roEditData, "warningRate", $$v)
      },
      expression: "roEditData.warningRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('watersystem.temperature-select-label')) + "\n                "), _c('v-select', {
    attrs: {
      "items": _vm.items,
      "rules": _vm.tempretureSelectRules,
      "item-text": "label",
      "item-value": "value",
      "label": _vm.selectTempretureItem,
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.validationType),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData, "validationType", $$v)
      },
      expression: "temperatureEditData.validationType"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-layout', [(_vm.temperatureEditData.validationType == 1) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMin,
      "rules": _vm.tempretureAlertRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.alertRate.min),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.alertRate, "min", $$v)
      },
      expression: "temperatureEditData.alertRate.min"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.temperatureEditData.validationType == 2) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMax,
      "rules": _vm.tempretureAlertRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.alertRate.max),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.alertRate, "max", $$v)
      },
      expression: "temperatureEditData.alertRate.max"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.temperatureEditData.validationType == 1) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMin,
      "rules": _vm.tempretureWarningRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.warningRate.min),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.warningRate, "min", $$v)
      },
      expression: "temperatureEditData.warningRate.min"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.temperatureEditData.validationType == 2) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMax,
      "rules": _vm.tempretureWarningRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.warningRate.max),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.warningRate, "max", $$v)
      },
      expression: "temperatureEditData.warningRate.max"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('watersystem.differential-pressure')
    },
    on: {
      "change": _vm.settingFormValidate
    },
    model: {
      value: (_vm.pressEditData.isDifferentialPressure),
      callback: function($$v) {
        _vm.$set(_vm.pressEditData, "isDifferentialPressure", $$v)
      },
      expression: "pressEditData.isDifferentialPressure"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.pressureUnit,
      "rules": _vm.pressureAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.pressEditData.alertRate),
      callback: function($$v) {
        _vm.$set(_vm.pressEditData, "alertRate", $$v)
      },
      expression: "pressEditData.alertRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.pressureUnit,
      "rules": _vm.pressureWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.pressEditData.warningRate),
      callback: function($$v) {
        _vm.$set(_vm.pressEditData, "warningRate", $$v)
      },
      expression: "pressEditData.warningRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.use-flow")) + "\n                "), _c('v-select', {
    attrs: {
      "items": _vm.flowsensors,
      "item-text": "name",
      "item-value": "id",
      "required": ""
    },
    model: {
      value: (_vm.flowEditData.pluginInfoId),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "pluginInfoId", $$v)
      },
      expression: "flowEditData.pluginInfoId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": (!_vm.settingDialogValid || _vm.isRoot)
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateConfig()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.execBtnName) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "nomal"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSettingDialog(false)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.cancel')) + "\n            ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-8ead1140","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceSettingDialog.vue
// module id = 1941
// module chunks = 0